import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaUserMd, FaCalendarAlt, FaMobileAlt, FaLock, FaSearch, FaUsers, FaCode, FaRocket, FaComments, FaBrain } from 'react-icons/fa';

const WebTerapeutasPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-psicologos", text: "Página web barata para psicólogos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-empresas", text: "Página web barata para empresas" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Capta pacientes mientras duermes",
      description: "Tu web trabaja 24/7, generando contactos incluso cuando no estás en consulta. Los potenciales pacientes pueden reservar cita online a cualquier hora."
    },
    {
      title: "Destaca frente a la competencia",
      description: "El 76% de los pacientes buscan terapeutas en Google antes de decidir. Con una web profesional te encontrarán primero a ti, no a tu competencia."
    },
    {
      title: "Reduce un 60% el tiempo en gestiones",
      description: "Las reservas online automatizan tu agenda. Cada hora que no pasas gestionando citas es una hora más que puedes dedicar a pacientes (o a tu vida personal)."
    },
    {
      title: "Genera confianza desde el primer clic",
      description: "Tu web profesional actúa como carta de presentación, mostrando tus especialidades, formación y enfoque terapéutico antes del primer contacto."
    },
    {
      title: "Retorno de inversión en pocas sesiones",
      description: "Con solo 2-3 pacientes nuevos al mes que lleguen por tu web, recuperas la inversión completa en el primer trimestre. Después todo son beneficios."
    },
    {
      title: "Comunica tu especialidad terapéutica",
      description: "Tu web transmite exactamente tu enfoque y especialización, atrayendo pacientes que buscan específicamente tu tipo de terapia, mejorando la compatibilidad."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaUserMd />,
      title: "Presentación profesional",
      description: "Diseño que inspira confianza y profesionalidad, con secciones para tu formación, especialización y enfoque terapéutico. Primera impresión impecable."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Sistema de citas online",
      description: "Agenda integrada que permite a los pacientes reservar, modificar o cancelar citas 24/7. Compatible con Google Calendar para evitar solapamientos."
    },
    {
      icon: <FaMobileAlt />,
      title: "100% adaptada a móviles",
      description: "El 70% de las búsquedas de servicios terapéuticos se hacen desde smartphones. Tu web se visualizará perfectamente en cualquier dispositivo."
    },
    {
      icon: <FaLock />,
      title: "Privacidad y seguridad RGPD",
      description: "Implementamos todas las medidas necesarias para cumplir con la protección de datos sanitarios. Formularios seguros, avisos legales y políticas específicas."
    },
    {
      icon: <FaSearch />,
      title: "Optimizada para atraer pacientes",
      description: "Posicionamiento SEO local para que te encuentren cuando busquen terapeutas en tu ciudad. Aparece entre los primeros resultados de Google."
    },
    {
      icon: <FaComments />,
      title: "Blog terapéutico incluido",
      description: "Sección de artículos para compartir tu conocimiento, mejorar tu posicionamiento y generar confianza con contenido de valor para potenciales pacientes."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web para Terapeutas Básica',
      price: 300,
      period: 'pago único',
      description: 'La opción más económica para comenzar a captar pacientes online.',
      features: [
        { text: 'Diseño profesional a medida', included: true },
        { text: 'Adaptable a móviles y tablets', included: true },
        { text: 'Presentación de servicios', included: true },
        { text: 'Formulario de contacto', included: true },
        { text: 'Optimización SEO básica', included: true },
        { text: 'Integración con Google Maps', included: true },
        { text: 'Enlaces a redes sociales', included: true },
        { text: 'Página de política de privacidad', included: true },
        { text: 'Sistema de citas online', included: false },
        { text: 'Blog terapéutico', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=terapeuta-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web para Terapeutas Profesional',
      price: 450,
      period: 'pago único',
      description: 'La más elegida. Todas las herramientas para gestionar pacientes online.',
      features: [
        { text: 'Diseño premium personalizado', included: true },
        { text: 'Adaptable a todos los dispositivos', included: true },
        { text: 'Presentación detallada de servicios', included: true },
        { text: 'Sistema de citas online', included: true },
        { text: 'Optimización SEO local avanzada', included: true },
        { text: 'Blog terapéutico (3 artículos iniciales)', included: true },
        { text: 'Formularios específicos por terapia', included: true },
        { text: 'Integración con WhatsApp Business', included: true },
        { text: 'Testimonios de pacientes', included: true },
        { text: 'Página de preguntas frecuentes', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=terapeuta-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web para Terapeutas Premium',
      price: 650,
      period: 'pago único',
      description: 'La solución completa para terapeutas que quieren destacar online.',
      features: [
        { text: 'Diseño exclusivo de alta gama', included: true },
        { text: 'Sistema avanzado de citas online', included: true },
        { text: 'Área privada para pacientes', included: true },
        { text: 'Blog terapéutico (5 artículos iniciales)', included: true },
        { text: 'Estrategia SEO completa', included: true },
        { text: 'Perfiles detallados de profesionales', included: true },
        { text: 'Integración con email marketing', included: true },
        { text: 'Cuestionarios previos personalizados', included: true },
        { text: 'Pasarela de pago para sesiones', included: true },
        { text: 'Configuración Google Business Profile', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=terapeuta-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Conocemos tu especialidad terapéutica, objetivos y necesidades específicas. Definimos la estructura ideal para tu web y el mensaje que quieres transmitir.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos tu web con un diseño profesional que inspira confianza, implementamos todas las funcionalidades necesarias y optimizamos los textos.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias de posicionamiento local para que los pacientes cercanos te encuentren en Google.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño enfocado en generar confianza",
      us: true,
      others: false
    },
    {
      label: "Especializados en terapeutas",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Sistema de citas compatible RGPD",
      us: true,
      others: false
    },
    {
      label: "Textos adaptados a tu enfoque",
      us: true,
      others: false
    },
    {
      label: "Formación personalizada en el uso",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Desde que tengo mi web profesional, la captación de pacientes ha aumentado considerablemente. El sistema de citas online ha reducido drásticamente las llamadas para gestionar agenda, y el blog me posiciona como referente en mi especialidad. La inversión se amortizó en apenas 2 meses con nuevos pacientes que encontraron mi consulta en Google. El mantenimiento mensual es un gasto mínimo comparado con los beneficios que me aporta.",
    author: "Marta Ramírez",
    position: "Terapeuta Gestalt",
    company: "Centro Terapéutico Bienestar",
    avatar: "/servicios/testimonios/terapeuta.webp"
  };
  
  const founderMessage = "Los terapeutas enfrentan un reto único: transmitir profesionalidad y a la vez cercanía emocional. Desarrollamos webs optimizadas para el ámbito terapéutico que equilibran perfectamente estos aspectos y simplifican la gestión de citas, permitiendo a estos profesionales centrarse en lo más importante: el bienestar de sus pacientes.";
  
  // FAQs específicas para web de terapeutas
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional como terapeuta?",
      answer: "Una web profesional es esencial para los terapeutas por varias razones clave: 1) El 78% de los potenciales pacientes buscan información online antes de elegir terapeuta, y sin presencia digital eres invisible para ellos; 2) Una web bien diseñada transmite profesionalidad y genera confianza antes del primer contacto, crucial en la relación terapéutica; 3) Te permite comunicar claramente tu especialización y enfoque, atrayendo pacientes más compatibles con tu método; 4) Un sistema de citas online reduce drásticamente el tiempo dedicado a gestiones administrativas (aproximadamente 5-7 horas semanales); 5) Te posiciona como autoridad en tu campo a través de contenidos de valor; 6) Permite la captación de pacientes 24/7, incluso fuera de tu horario de consulta; 7) Ofrece información práctica que reduce llamadas informativas básicas. Nuestros clientes terapeutas reportan un incremento medio del 40% en nuevos pacientes durante los primeros 6 meses tras lanzar su web profesional.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo funciona el sistema de citas online?",
      answer: "Nuestro sistema de citas online está especialmente diseñado para terapeutas y funciona así: 1) El paciente accede a la sección de reservas y ve tu disponibilidad real en un calendario intuitivo; 2) Selecciona fecha, hora y tipo de sesión (primera consulta, seguimiento, etc.); 3) Completa un breve formulario con sus datos y motivo de consulta (personalizable según tus necesidades); 4) Recibe confirmación automática por email/SMS con recordatorio de cita; 5) Tú recibes notificación de la nueva cita que se integra automáticamente en tu Google Calendar o software de gestión; 6) El sistema envía recordatorios 24h antes para reducir las cancelaciones. El sistema cumple completamente con el RGPD, con consentimientos explícitos para el tratamiento de datos sanitarios, y permite bloquear franjas horarias, establecer tiempos entre citas, y gestionar cancelaciones/modificaciones automáticamente. Según nuestras estadísticas, reduce en un 70% el tiempo dedicado a la gestión de agenda y disminuye las incomparecencias en un 60% gracias a los recordatorios.",
      category: "Funcionalidades"
    },
    {
      question: "¿Mis datos y los de mis pacientes estarán seguros?",
      answer: "La seguridad y confidencialidad son nuestra prioridad absoluta, especialmente tratándose de datos sanitarios: 1) Implementamos todas las medidas técnicas y legales para cumplir con el RGPD y la normativa específica de datos de salud; 2) Utilizamos conexiones seguras SSL en toda la web (https) y especialmente en formularios; 3) Los formularios de contacto y sistema de citas incluyen cláusulas específicas de consentimiento para datos sanitarios; 4) Implementamos políticas de privacidad especializadas para profesionales sanitarios; 5) Los servidores están ubicados en la UE, cumpliendo la normativa europea; 6) Realizamos copias de seguridad diarias encriptadas; 7) El sistema de citas almacena solo la información mínima necesaria para la gestión; 8) Proporcionamos contratos de encargado de tratamiento cuando es necesario. Además, te formamos en buenas prácticas de privacidad para la gestión de datos de pacientes, como el uso correcto del email profesional y el almacenamiento seguro de información sensible. Trabajamos con más de 50 profesionales sanitarios que confían en nuestros estándares de seguridad.",
      category: "Privacidad"
    },
    {
      question: "¿Puedo ofrecer terapia online a través de la web?",
      answer: "Absolutamente. Implementamos sistemas para facilitar la terapia online con estas funcionalidades: 1) Integración con plataformas de videoconsulta seguras como Zoom Professional, Google Meet o Microsoft Teams; 2) Sistema de reserva específico para sesiones online con envío automático de enlaces de conexión; 3) Pasarela de pago segura para abonar las sesiones por adelantado; 4) Área privada donde los pacientes pueden acceder a materiales, ejercicios o documentación complementaria; 5) Formularios previos a la sesión para recopilar información relevante; 6) Configuración técnica para garantizar conexiones estables y seguras. La terapia online representa una oportunidad de crecimiento significativo, permitiéndote ampliar tu radio de acción geográfico y atender a pacientes con limitaciones de movilidad o tiempo. Nuestros terapeutas con sistema online han incrementado sus ingresos en un 30-40% de media al expandir su base de pacientes más allá de su localidad. Además, te asesoramos sobre aspectos legales específicos de la telepsicología o teleterapia.",
      category: "Terapia Online"
    },
    {
      question: "¿Qué contenido debería incluir en mi web como terapeuta?",
      answer: "Una web efectiva para terapeutas debe incluir estos elementos clave: 1) Página de inicio que transmita confianza, con una clara propuesta de valor y llamada a la acción; 2) Sección 'Sobre mí' con tu formación, enfoque terapéutico y especialidades (con foto profesional); 3) Descripción detallada de servicios y especialidades terapéuticas, explicando brevemente en qué consisten y para qué problemas son adecuadas; 4) Información clara sobre tarifas y modalidades (presencial/online); 5) Sistema de reserva o contacto prominente y accesible desde cualquier página; 6) Testimonios anónimos de pacientes (respetando confidencialidad); 7) FAQ respondiendo dudas comunes sobre tu terapia; 8) Blog con artículos sobre temas de tu especialidad; 9) Ubicación con mapa e instrucciones de acceso; 10) Políticas de privacidad y cancelación. Los contenidos deben equilibrar profesionalidad con cercanía, utilizando un lenguaje accesible pero preciso. Te ayudamos a redactar todos estos contenidos si no dispones de ellos, basándonos en una entrevista detallada sobre tu práctica. La estructura ideal varía según tu especialidad terapéutica, por eso personalizamos cada proyecto.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo se mantiene actualizada la web?",
      answer: "El mantenimiento de tu web está completamente cubierto por la cuota mensual de 20€ e incluye: 1) Alojamiento en servidores de alta velocidad; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Actualizaciones de seguridad y técnicas mensuales; 5) Copias de seguridad diarias; 6) Soporte técnico por email y teléfono; 7) Modificaciones menores de contenido (textos, imágenes, horarios); 8) Monitorización de rendimiento y disponibilidad. Además, te proporcionamos acceso a un panel intuitivo donde podrás actualizar por ti mismo aspectos como: publicar nuevos artículos en el blog, modificar disponibilidad en el calendario, añadir nuevos servicios o actualizar información de contacto. Para cambios mayores o rediseños sustanciales, ofrecemos tarifas reducidas por ser cliente de mantenimiento. Realizamos revisiones trimestrales para sugerirte mejoras basadas en el comportamiento de los usuarios y las tendencias del sector. No existen costes ocultos ni sorpresas; todo está incluido en la cuota mensual.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para terapeutas
      pageTitle="Web para Terapeutas desde 300€ | Atrae Pacientes y Gestiona Citas Online"
      pageDescription="Diseño web profesional para terapeutas. Sistema de citas online, blog terapéutico y diseño que genera confianza. Optimizada para atraer pacientes en tu zona."
      pageKeywords="página web barata terapeutas, web para terapeutas, diseño web terapias, web con citas online terapeutas, web para profesionales sanitarios"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-terapeutas"
      
      // Hero adaptado al buyer persona
      heroTitle="Web profesional para terapeutas desde solo 200€"
      heroSubtitle="Diseñamos webs para terapeutas que transmiten confianza, comunican tus servicios y captan clientes. Sin complicaciones técnicas, lista en 7 días."
      heroImage="/servicios/tipo-cliente/hero-terapeutas.webp"
      badges={['Desde 200€ (pago único)', 'Sin permanencia', 'Optimizada para SEO local', 'Soporte incluido']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para terapeutas y profesionales de la salud"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para terapeutas?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Miguel Vela"
          founderTitle="Co-fundador y Director de Desarrollo"
          avatarSrc="/sobre nosotros/foto-miguel.webp"
        />
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos frente a otras opciones?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Beneficios de una web profesional para tu consulta"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para terapeutas"
      faqCategories={["Beneficios", "Funcionalidades", "Privacidad", "Terapia Online", "Contenidos", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu consulta con una web profesional"
      ctaDescription="Una inversión inteligente que te permite captar pacientes 24/7 y optimizar tu tiempo. Recupera la inversión con solo 2-3 pacientes nuevos."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebTerapeutasPage; 

